import React from "react";
import "./Contact.scss";
import {Redirect, Route, Switch} from "react-router-dom";
import {ContactUs} from "./components/ContactUs/ContactUs";
import {ContactHire} from "./components/ContactHire/ContactHire";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../locales/config";

export function Contact() {
    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            <Switch>
                <Route exact path="/contact" component={() => <Redirect to="/contact/us"/>}/>
                <Route path="/contact/us" component={ContactUs}/>
                {lang === DEFAULT_LOCALE
                    ? <Route path="/contact/hire" component={ContactHire}/>
                    : <Route path="/contact/hire" component={() => <Redirect to="/contact/us"/>}/>}
            </Switch>
        </>
    )
}
